<template>
	<el-dialog class="cooperationProgress_monitoring_dialog" :close-on-click-modal="false" :visible.sync="dialogVisible" width="540px">
		<div slot="title">
			<span class="fz-14 yx-pingfang-Medium yx-color-g-9">更新达人档期</span>
		</div>
		<div class="pl-8 pr-8">
			<div class="cooperationProgress_dialog_tips radius-4 flex-row-align-center">
				<i class="el-icon-info iconfont-color"></i>
				<span class="font-h6-regular yx-color-text-primary ml-4">提交后将在【工作台-直播/视频日历】中展示</span>
			</div>
		</div>
		<div class="flex-row cooperationProgress_item_star ml-8 mr-8 mt-16 pt-16 pb-4">
			<yx-avatar :size="36" class="mr-8 ml-16" :src="info.head" />
			<div class="font-h6-regular yx-pingfang-regular pr-16">
				<div v-if="info.anchor_name" class="flex-row-align-center">
					<platform-icon style="flex-shrink: 0" :platformId="info.platform_id" />
					<el-tooltip placement="top" content="查看达人详情">
						<div class="ml-4 cooperationProgress_item_star_name yx-pingfang-Medium cursor-pointer line-ellipsis-1">
							{{ info.anchor_name }}
						</div>
					</el-tooltip>
					<level-tag v-if="$isDy(info.platform_id)" class="ml-4" :lv="`${info.anchor_level}`" />
				</div>
				<div v-else class="cooperationProgress_item_star_name">无关联达人</div>
				<div v-if="info.anchor_name" class="yx-color-text-secondary flex-row-align-center">
					<span style="white-space: nowrap">{{ info.platform_id | formatPlatformName('unify') }}：</span>
					<span>{{ anchorAccount | formatEmpty | textFormat(15) }}</span>
					<i @click="handleCopy(anchorAccount)" class="el-icon-copy-document cursor-pointer ml-6"></i>
				</div>
				<div v-if="info.institution_info && info.institution_info.institution_name" class="yx-color-text-secondary">
					团长名称 {{ info.institution_info.institution_name }}
				</div>
			</div>
		</div>
		<div class="flex-row-align-center ml-8 mr-8 mt-16 delivery-time">
			<span class="mr-12 yx-color-text-primary fz-14">预计交付时间</span>
			<el-date-picker class="flex-1" v-model="timesTamp" type="datetime" value-format="timestamp" placeholder="请选择日期"></el-date-picker>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button style="width: 76px" @click="dialogVisible = false">取 消</el-button>
			<el-button style="width: 76px" type="primary" @click="handleSubmit">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>

import { cooperationAuthorSchedule } from '@/api/cooperationProgress';
import { copy } from '@/utils/common';
export default {
	data() {
		return {
			dialogVisible: false,
			timesTamp: '',
			begin_time: '',
			start_time: '',

			info: {},
		};
	},
	components: {
		
	},
	computed: {
		anchorAccount() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.info.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.info.anchor_account,
				[dataMap.PLATFORM_SP.value]: this.info.anchor_uid,
			};
			return temPF[this.info.platform_id];
		},
	},
	methods: {
		show(info) {
			this.dialogVisible = true;
			this.timesTamp = '';
			this.info = info;
		},
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		handleSubmit() {
			cooperationAuthorSchedule({
				cooperateId: this.info.cooperate_id,
				predictDeliveryTime: this.timesTamp / 1000,
			}).then(res => {
				if (res.code !== 0) return;
				this.$emit('refreshList');
				this.dialogVisible = false;
			});
		},
	},
};
</script>

<style lang="less" scoped>
.cooperationProgress_dialog_tips {
	background: #fff0eb;
	padding: 8px 17px 8px 18px;
	border: 1px solid #ffe2d7;
	.iconfont-color {
		color: @color-o;
	}
}
.cooperationProgress_monitoring_dialog {
	::v-deep .el-dialog__header {
		padding-top: 16px;
		padding-bottom: 16px;
		padding-left: 24px;
	}
	::v-deep .el-dialog__body {
		padding-top: 10px !important;
	}
}
.cooperationProgress_item_star {
	.cooperationProgress_item_star_name {
		color: #1d2129;
	}
	.cooperationProgress_item_star_cursor {
		cursor: default;
	}
}
.delivery-time {
	padding: 16px;
	background: #f7f8f9;
}
</style>
